import { faInfo, faEdit, faTrash, faFilter } from '@fortawesome/free-solid-svg-icons'
import TableComp from '../../components/Table'
import CustomTitle from '../../components/CustomTitle'
import ButtonIcon from '../../components/ButtonComp'
import CustomLayout from 'components/Layout'

type Props = {}

const IncidentManagement = (props: Props) => {
    return (
        <CustomLayout>
            <CustomTitle
                title='Gestión de incidentes'
                actions={[
                    <ButtonIcon icon={faFilter} tooltip='Filtrar resultados' variant='outline-primary'/>
                ]}
            />
            <TableComp
                headers={['#', 'Tipo de Incidente', 'Ubicación', 'Estado', 'Reportado en', 'Acciones']}
                keys={['id', 'incident_type', 'location', 'status', 'reported_at']}
                body={[
                    { id: 1, incident_type: "Accidente", location: "KM 10+200", status: "En curso", reported_at: "2025-01-26T10:00:00" },
                    { id: 2, incident_type: "Congestión", location: "KM 5+500", status: "Resuelto", reported_at: "2025-01-25T15:30:00" },
                    { id: 3, incident_type: "Vehículo averiado", location: "KM 3+800", status: "Pendiente", reported_at: "2025-01-24T11:45:00" },
                    { id: 4, incident_type: "Obstrucción", location: "KM 7+400", status: "En curso", reported_at: "2025-01-23T08:20:00" },
                    { id: 5, incident_type: "Incendio", location: "KM 2+600", status: "Resuelto", reported_at: "2025-01-22T22:10:00" },
                    { id: 6, incident_type: "Derrame de carga", location: "KM 6+900", status: "En curso", reported_at: "2025-01-21T16:30:00" },
                    { id: 7, incident_type: "Accidente", location: "KM 8+500", status: "Pendiente", reported_at: "2025-01-20T12:00:00" },
                    { id: 8, incident_type: "Vehículo abandonado", location: "KM 4+100", status: "Resuelto", reported_at: "2025-01-19T07:30:00" },
                ]}
                actions={[
                    { 
                        icon: faInfo, 
                        handleClick: (row: any) => { console.log("Ver detalles del incidente:", row); }, 
                        tooltip: "Ver detalles", 
                        variant: "outline-primary" 
                    },
                    { 
                        icon: faEdit, 
                        handleClick: (row: any) => { console.log("Editar incidente:", row); }, 
                        tooltip: "Editar", 
                        variant: "outline-success" 
                    },
                    { 
                        icon: faTrash, 
                        handleClick: (row: any) => { console.log("Eliminar incidente:", row); }, 
                        tooltip: "Eliminar", 
                        variant: "outline-danger" 
                    },
                ]}
                moment_dates={[{ index: 4, format: "LLL" }]}
            />
        </CustomLayout>
    )
}

export default IncidentManagement;
